import { useTranslation } from 'react-i18next';
export const useTranslations = (obj: any, options: object, ...keys: any): Pick<any, any> => {
  const { t } = useTranslation();
  keys.forEach((key: string) => (obj[key] = t(key, options)));
  return obj;
};
